import React, { FunctionComponent, useState } from 'react';
import { brochureUrlVar } from '../../../../../gqlCommon/graphql/cache';
import urlRoute from '../../../../../gqlCommon/service/urlRoute';
import useWidgetContext from '../../../../../common/react/useWidgetContext';
import SectionLoader from '../../../../../common/components/loaders/SectionLoader';
import OverlayLoader from '../../../presentational/loaders/OverlayLoader';
import SpecificationsAndFeatures from './SpecificationsAndFeatures';
import SpecificationsModal from './specificationsModal/SpecificationsModal';
import { GetCustomizeCarModel_customizeCar_car_keyFeatures } from '../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export interface ISpecificationsAndFeaturesContainer {
  oemCode?: string;
  keyFeatures: GetCustomizeCarModel_customizeCar_car_keyFeatures[];
  specDescription?: string[];
}

const SpecificationsAndFeaturesContainer: FunctionComponent<ISpecificationsAndFeaturesContainer> = ({
  oemCode,
  keyFeatures,
  specDescription,
}) => {
  const {
    platformConfig: { specificationsBrochureUrl: newSpecificationsBrochureUrl },
  } = usePlatformConfig();
  const {
    spc: { customise },
  } = useTheme<ISpcTheme>();
  // @TODO migrate specificationsBrochureUrl to config management once all the market has been migrated
  const {
    configuration: { specificationsBrochureUrl },
  } = useWidgetContext();
  const { selectedCar, loading } = useCustomizeCarContext();
  const brochureFile = selectedCar?.car.attributes.brochureFile;
  const oemCodeUrl = urlRoute.joinUrl(specificationsBrochureUrl, oemCode ? `${oemCode}.pdf` : '');
  const brochureUrlWithOemCode = specificationsBrochureUrl && oemCodeUrl;
  const newBrochureUrlWithFilename =
    newSpecificationsBrochureUrl && `${newSpecificationsBrochureUrl}${brochureFile ? `${brochureFile}.pdf` : ''}`;
  const brochureUrl = newBrochureUrlWithFilename || brochureUrlWithOemCode;

  brochureUrlVar(brochureUrl);

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (loading && !keyFeatures?.length && !specDescription?.length) {
    return <SectionLoader />;
  }

  return (
    <OverlayLoader loading={!customise?.hideModelContainerLoader && loading} width={'100%'}>
      <SpecificationsAndFeatures
        specifications={specDescription}
        keyFeatures={keyFeatures}
        openModal={() => setIsModalOpen(true)}
      />
      <SpecificationsModal isOpen={isModalOpen} toggleModal={setIsModalOpen} />
    </OverlayLoader>
  );
};

export default SpecificationsAndFeaturesContainer;
